module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_WestHamUtd.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_WestHamUtd.png
// module id = 2094
// module chunks = 4